import type {
  AvailabilityDistributionApartment,
  AvailabilityDistributionChannelCloseout,
} from '@/shared/api';
import { buildApartmentModel } from './calendarModel';

/**
 * Welche Zeichen des Wohnungsverbunds der geladene Zeitraum zeigt — nur die erklärt die Legende.
 * Abgeleitet aus demselben Zellmodell wie das Raster, damit Legende und Zelle nie auseinanderlaufen.
 */
export function familyMarks(
  apartments: readonly AvailabilityDistributionApartment[],
  closeouts: readonly AvailabilityDistributionChannelCloseout[],
): { closedByFamily: boolean; doubleBooked: boolean } {
  const kinds = new Set(
    apartments.flatMap((apartment) =>
      buildApartmentModel(apartment, closeouts).cells.map((cell) => cell.kind),
    ),
  );
  return { closedByFamily: kinds.has('closedByFamily'), doubleBooked: kinds.has('doubleBooked') };
}
